const API_BASE_URL =
  'https://script.google.com/macros/s/AKfycbxbMJHFGKBoIOGHAq2RqZkLF-JgYFJiu3UvFMC8oKN_onrN4O6i6AmCijYjKTg7b963/exec';

/**
 * Submit contact form data
 * @param {FormData} formData - Form data containing name, email, phone, period
 * @returns {Promise<void>}
 */
export const submitContactForm = async (formData) => {
  const response = await fetch(API_BASE_URL, {
    method: 'POST',
    body: formData,
  });

  if (!response.ok) {
    throw new Error('Failed to submit form');
  }

  return response;
};

/**
 * Get user status by email
 * @param {string} email - User email address
 * @returns {Promise<{name: string, email: string, startDate: string, endDate: string, status: string}>}
 */
export const getUserStatus = async (email) => {
  if (!email || !email.trim()) {
    throw new Error('Email is required');
  }

  const url = `${API_BASE_URL}?email=${encodeURIComponent(email.trim())}`;
  const response = await fetch(url, {
    method: 'GET',
  });

  if (!response.ok) {
    throw new Error('Failed to fetch status');
  }

  const data = await response.json();

  if (!data || !data.data) {
    throw new Error('No status found for this email address');
  }

  return data.data;
};

